<main class="flex flex-col items-center px-4 pt-16">
  <h1 class="mb-8" i18n>Oops! Erreur 404.</h1>
  <p class="text-2xl mb-8" i18n>Désolé, mais la page que vous recherchez est introuvable.</p>
  <a class="qo-MainRoundedBtn mb-16" [routerLink]="NavigationService.Routes.Home()" i18n>Revenir à la page d'accueil</a>
  <img class="mb-32" [src]="assetsPath + 'not-found.svg'" alt="" />

  <div class="mb-8">
    <qo-poster-list [multiline]="true"></qo-poster-list>
  </div>
</main>
